import api from '../../components/api'
import { ApprovedPaymentSummary } from "./paymentSummary"

export const getApprovedPaymentSummaries = async (jobId: number): Promise<ApprovedPaymentSummary[]>=> {
  return (await api.get(`/web/proposals/${jobId}/approved-payment-summaries`)).data
}
